<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ $t("sound") }}
        </label>
      </v-system-bar>

      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="this.$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="300"
            height="60"
            class="report-title-text-mobile"
          >
            {{ $t("sound") }}</title-block
          >
        </v-flex>
      </v-layout>
      <!-- fluid -->
      <v-row justify="space-between" class="ma-3">
        <v-col cols="12" lg="3">
          <v-text-field
            outlined
            dense
            clearable
            hide-details
            style="border-radius: 8px"
            prepend-inner-icon="mdi-magnify"
            :placeholder="$t('search')"
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          dark
          class="add_btn text-capitalize white--text"
          color="#A6CC39"
          style="border-radius: 8px !important"
          @click="AddSound()"
        >
          <v-icon style="color: #fffffff" class="mr-1" :small="true"
            >mdi-plus-box-outline</v-icon
          >
          <span style="font-size: 14px; color: #ffffff">{{
            $t("Add New")
          }}</span>
        </v-btn>
      </v-row>
      <v-row class="ma-1">
        <v-col>
          <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="soundItems"
            hide-default-footer
            :search="search"
            @page-count="pageCount = $event"
            :page.sync="page"
            :items-per-page="itemsPerPage"
          >
            <template v-slot:item.img="{ item }">
              <v-img :src="item.pictureBackground" class="articleimg"></v-img>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                text
                color="#4FB14E"
                class="text-capitalize"
                style="font-size: 16px"
                @click="$store.commit('saveEditSound', item), editSound()"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
                {{ $t("edit") }}
              </v-btn>
              <v-btn
                @click="checkSoundDelete(item)"
                text
                color="#FF6060"
                style="font-size: 16px"
                class="text-capitalize"
              >
                <v-icon>mdi-delete-outline</v-icon>
                {{ $t("delete") }}
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="space-between" class="mx-6 my-4">
        <v-row>
          <v-col cols="auto" class="mr-auto">
            <v-pagination
              circle
              v-model="page"
              class="pagination"
              :length="pageCount"
            ></v-pagination>
          </v-col>
          <v-col cols="12" lg="2" md="3" sm="4" class="d-flex justify-end">
            <p class="mt-3 pr-4">{{ $t("Show") }}</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  width="70"
                  v-bind="attrs"
                  v-on="on"
                  style="border: 1px solid #c0c0c0; opacity: 1"
                  class="text-capitalize mt-1"
                  outlined
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in paginationCount"
                  :key="index"
                  @click="itemsPerPage = item.title"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-row>
    </v-card>

    <Add
      :show="addDialog"
      @close="addDialog = false"
      :full_name="fullName_"
      @confirm="
        (addDialog = false),
          (successDialog = true),
          (message = $t('Add Sound Successful'))
      "
    />
    <Edit
      :show="editDialog"
      @close="
        (editDialog = false), $store.commit('removeFirstTimeEditDataForArticle')
      "
      @confirm="
        (editDialog = false),
          (successDialog = true),
          (message = $t('Update Sound Successful'))
      "
    />
    <DeleteConfirmDialog
      :show="deleteDialog"
      :text="deleteMessage"
      @close="deleteDialog = false"
      @confirm="confirmDelete"
    />
    <SuccessDialog
      :show="successDialog"
      :title="$t('success')"
      :text="message"
      @close="(successDialog = false), getSound()"
    />
  </div>
</template>

<script>
import TitleBlock from "@/components/global_component/TitleBlock";
import DeleteConfirmDialog from "@/components/DeleteConfirmDialog.vue";
import SuccessDialog from "@/components/SuccessDialog.vue";
import store from "@/store";
import Add from "./addsound.vue";
import Edit from "./editsound.vue";
import axios from "axios";
import enurl from "@/api/environment";
import * as moment from "moment/moment";

export default {
  name: "report",
  components: {
    TitleBlock,
    Add,
    Edit,
    DeleteConfirmDialog,
    SuccessDialog
  },

  data() {
    return {
      url: enurl.apiUrl,
      search: "",
      message: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
      addDialog: false,
      editDialog: false,
      fullName_: "",
      soundItems: [],
      editData: {},
      deleteDialog: false,
      loading: true,
      successDialog: false,
      deleteData: {}
    };
  },

  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "no",
          width: "63px"
        },
        {
          text: this.$t("Cover"),
          align: "left",
          value: "img",
          width: "150px"
        },
        {
          text: this.$t("Title"),
          align: "left",
          value: "lessonName",
          width: "180px"
        },
        {
          text: this.$t("Number of Add"),
          align: "center",
          value: "countAddLibrary",
          width: "150px"
        },
        {
          text: this.$t("Number of Views"),
          align: "center",
          value: "countView",
          width: "150px"
        },
        {
          text: this.$t("Create Date"),
          align: "center",
          value: "createDate",
          width: "160px"
        },
        {
          text: this.$t("Manage"),
          align: "center",
          value: "actions",
          width: "235px"
        }
      ];
    },
    items() {
      return [
        {
          img: require("@/assets/imgs/img-01@3x.png"),
          title: "Sample",
          numberofadd: 2,
          numberofviews: 1,
          create_Date: "26/6/2023"
        }
      ];
    },
    deleteMessage() {
      return `Are you sure you want to delete "${this.deleteData.lessonName}" ?`;
    }
  },

  mounted: function() {
    this.fullName_ = store.getters.username;
    this.getSound();
  },

  methods: {
    async checkSoundDelete(item) {
      let self = this;
      self.deleteDialog = true;
      self.deleteData = item;
    },
    async confirmDelete() {
      const res = await axios.post(`${this.url}Video/RemoveVideoContent`, {
        id: this.deleteData.id
      });
      if (res.data.status == 0) {
        this.deleteDialog = false;
        this.successDialog = true;
        this.message = this.$t("Delete Sound");
      }
    },
    async AddSound() {
      let self = this;
      self.addDialog = true;
    },
    async editSound() {
      let self = this;
      self.editDialog = true;
    },
    async getSound() {
      let self = this;
      self.loading = true;
      axios
        .get(`${self.url}Video/GetVideoContentFromProductAdmin`)
        .then(function(response) {
          self.soundItems = response.data.data.map((v, i) => ({
            ...v,
            no: i + 1,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY")
          }));
          self.loading = false;
        })
        .catch(function(error) {});
    }
  }
};
</script>

<style scoped>
.articleimg {
  margin: 10px 0px;
  border-radius: 20px;
  height: 135px;
  width: 250px !important;
}
.add_btn {
  margin-top: 15px;
  margin-right: 12px;
  color: #fff;
  font-size: 18px;
  z-index: 0;
  position: relative;
  display: inline-block;
}
.add_btn:before {
  background-color: #4fb14e;
  content: "";
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  opacity: 0.5 !important;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
}
.add_btn:hover:before {
  background-color: #4fb14e;
  top: 0;
}
.add_btn:hover {
  transition: 0.25s;
}
.add_btn:after {
  position: absolute;
  right: 2.34375rem;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(50%);
  -ms-transform: translateY(-50%) translateX(50%);
  transform: translateY(-50%) translateX(50%);
}
/* ::v-deep .v-pagination__item {
  opacity: 1 !important;
} */
::v-deep tr:nth-child(even) {
  background: unset;
}
::v-deep .v-label {
  font-size: 20px !important;
}
::v-deep .v-text-field__slot {
  font-size: 20px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
  vertical-align: top;
}
::v-deep .v-dialog {
  border-radius: 35px !important;
}
::v-deep .primary {
  color: #000000 !important;
  background-color: #a6cc39 !important;
  opacity: 1;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  opacity: 1;
}

/* For Sort menu. */
::v-deep .sort_Btn.v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px;
  font-size: 16px;
  border: 1px solid #c0c0c0; /**#47484b */
  border-radius: 8px;
  opacity: 1 !important;
  padding: 0 0;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar {
  width: 7px !important;
}
/* Track */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-track {
  width: 6px !important;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}
/* Handle */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}
::v-deep .v-list-item {
  min-height: 32px;
  border-top: 2px solid #707070;
}
::v-deep .v-list-item:hover {
  background-color: #707070 !important;
}
::v-deep
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  color: #ffffff !important;
}
/* end sort menu. */
</style>

<style scoped>
@media (min-width: 1264px) {
  .container {
    max-width: unset !important;
    margin-top: 1.5rem !important;
  }
}
::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
</style>
